module.exports = require("react-dom/server.browser");